import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ISortConfig, LicenseTypeNature } from '../../../types';
import { type SearchResult } from '../../../@types/serviceTypes';

import type { ILicenseSearchResult } from './types';
import { initialState } from './initialState';

export const licenses = createSlice({
  name: 'licenses',
  initialState,
  reducers: {
    setNewLicenses: (
      state,
      {
        payload: {
          searchResult: { resultList, totalCount },
          licenseTypeNature = LicenseTypeNature.LPCO,
        },
      }: PayloadAction<{ searchResult: SearchResult<ILicenseSearchResult>; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].newLicenses.data = resultList;
      state[licenseTypeNature].newLicenses.totalCount = totalCount;
    },
    setNewLicensesLoading: (
      state,
      {
        payload: { loading, licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ loading: boolean; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].newLicenses.isLoading = loading;
    },
    resetNewLicensesData: (
      state,
      {
        payload: { licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].newLicenses.data = [];
      state[licenseTypeNature].newLicenses.totalCount = 0;
    },
    setNewLicensesSortConfig: (
      state,
      {
        payload: { sortConfig, licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ sortConfig: ISortConfig<ILicenseSearchResult>; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].newLicenses.sortConfig = sortConfig;
    },
    setNewLicensesPagination: (
      state,
      {
        payload: { currentPage, licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ currentPage: number; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].newLicenses.pagination.currentPage = currentPage;
    },
    setLicenses: (
      state,
      {
        payload: {
          searchResult: { resultList, totalCount },
          licenseTypeNature = LicenseTypeNature.LPCO,
        },
      }: PayloadAction<{ searchResult: SearchResult<ILicenseSearchResult>; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].licenses.data = resultList;
      state[licenseTypeNature].licenses.totalCount = totalCount;
    },
    setLicensesLoading: (
      state,
      {
        payload: { loading, licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ loading: boolean; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].licenses.isLoading = loading;
    },
    resetLicensesData: (
      state,
      {
        payload: { licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].licenses.data = [];
      state[licenseTypeNature].licenses.totalCount = 0;
    },
    setLicensesSortConfig: (
      state,
      {
        payload: { sortConfig, licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ sortConfig: ISortConfig<ILicenseSearchResult>; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].licenses.sortConfig = sortConfig;
    },
    setLicensesPagination: (
      state,
      {
        payload: { currentPage, licenseTypeNature = LicenseTypeNature.LPCO },
      }: PayloadAction<{ currentPage: number; licenseTypeNature?: LicenseTypeNature }>
    ) => {
      state[licenseTypeNature].licenses.pagination.currentPage = currentPage;
    },
  },
});

export const {
  setNewLicenses,
  setNewLicensesLoading,
  resetNewLicensesData,
  setNewLicensesSortConfig,
  setNewLicensesPagination,
  setLicenses,
  setLicensesLoading,
  resetLicensesData,
  setLicensesSortConfig,
  setLicensesPagination,
} = licenses.actions;
